import { takeLatest } from "redux-saga/effects";
import { fork } from "redux-saga/effects";
import {
  sagaList,
  sagaOne,
  sagaCreate,
  sagaUpdate,
  sagaSearch,
  sagaDelete
} from "../actions/ActionTypes";
import {
  fetchAdmins,
  fetchAdmin,
  createAdmin,
  updateAdmin,
  changeAdminPassword
} from "./admins";

import {
  fetchAssets,
  fetchAsset,
  searchAssets,
  createAsset,
  updateAsset
} from "./assets";

import {
  fetchMembers,
  fetchMember,
  searchMembers,
  createMember,
  updateMember,
  deleteMember
} from "./members";

import {
  fetchMeditations,
  fetchMeditation,
  searchMeditations,
  createMeditation,
  updateMeditation
} from "./meditations";

import {
  fetchEvents,
  fetchEvent,
  searchEvents,
  createEvent,
  updateEvent
} from "./events";

import {
  fetchPrayers,
  fetchPrayer,
  searchPrayers,
  createPrayer,
  updatePrayer
} from "./prayers";

import {
  fetchPreachers,
  fetchPreacher,
  searchPreachers,
  createPreacher,
  updatePreacher
} from "./preachers";

import {
  fetchNotices,
  fetchNotice,
  searchNotices,
  createNotice,
  updateNotice
} from "./notices";

import {
  fetchNoticeCategories,
  fetchNoticeCategory,
  searchNoticeCategories,
  createNoticeCategory,
  updateNoticeCategory
} from "./notice_categories";

import { fetchReportSummaries } from "./reports";
import { fetchMemberLookups } from "./member_lookups";
import { signin } from "./auth";

export function* sagas() {
  yield [
    fork(takeLatest, sagaList("meditations"), fetchMeditations),
    fork(takeLatest, sagaSearch("meditations"), searchMeditations),
    fork(takeLatest, sagaOne("meditation"), fetchMeditation),
    fork(takeLatest, sagaCreate("meditation"), createMeditation),
    fork(takeLatest, sagaUpdate("meditation"), updateMeditation),

    fork(takeLatest, sagaList("members"), fetchMembers),
    fork(takeLatest, sagaSearch("members"), searchMembers),
    fork(takeLatest, sagaOne("member"), fetchMember),
    fork(takeLatest, sagaCreate("member"), createMember),
    fork(takeLatest, sagaUpdate("member"), updateMember),
    fork(takeLatest, sagaDelete("member"), deleteMember),

    fork(takeLatest, sagaList("events"), fetchEvents),
    fork(takeLatest, sagaSearch("events"), searchEvents),
    fork(takeLatest, sagaOne("event"), fetchEvent),
    fork(takeLatest, sagaCreate("event"), createEvent),
    fork(takeLatest, sagaUpdate("event"), updateEvent),

    fork(takeLatest, sagaList("assets"), fetchAssets),
    fork(takeLatest, sagaSearch("assets"), searchAssets),
    fork(takeLatest, sagaOne("asset"), fetchAsset),
    fork(takeLatest, sagaCreate("asset"), createAsset),
    fork(takeLatest, sagaUpdate("asset"), updateAsset),

    fork(takeLatest, sagaList("prayers"), fetchPrayers),
    fork(takeLatest, sagaSearch("prayers"), searchPrayers),
    fork(takeLatest, sagaOne("prayer"), fetchPrayer),
    fork(takeLatest, sagaCreate("prayer"), createPrayer),
    fork(takeLatest, sagaUpdate("prayer"), updatePrayer),

    fork(takeLatest, sagaList("preachers"), fetchPreachers),
    fork(takeLatest, sagaSearch("preachers"), searchPreachers),
    fork(takeLatest, sagaOne("preacher"), fetchPreacher),
    fork(takeLatest, sagaCreate("preacher"), createPreacher),
    fork(takeLatest, sagaUpdate("preacher"), updatePreacher),

    fork(takeLatest, sagaList("notices"), fetchNotices),
    fork(takeLatest, sagaSearch("notices"), searchNotices),
    fork(takeLatest, sagaOne("notice"), fetchNotice),
    fork(takeLatest, sagaCreate("notice"), createNotice),
    fork(takeLatest, sagaUpdate("notice"), updateNotice),

    fork(takeLatest, sagaList("noticeCategories"), fetchNoticeCategories),
    fork(takeLatest, sagaSearch("noticeCategories"), searchNoticeCategories),
    fork(takeLatest, sagaOne("noticeCategory"), fetchNoticeCategory),
    fork(takeLatest, sagaCreate("noticeCategory"), createNoticeCategory),
    fork(takeLatest, sagaUpdate("noticeCategory"), updateNoticeCategory),

    fork(takeLatest, sagaList("admins"), fetchAdmins),
    fork(takeLatest, sagaOne("admin"), fetchAdmin),
    fork(takeLatest, sagaCreate("admin"), createAdmin),
    fork(takeLatest, sagaUpdate("admin"), updateAdmin),
    fork(takeLatest, "SAGA_CHANGE_ADMIN_PASSWORD", changeAdminPassword),

    fork(takeLatest, "SAGA_LOGIN", signin),
    fork(takeLatest, sagaList("member_lookups"), fetchMemberLookups),
    fork(takeLatest, sagaList("report_summaries"), fetchReportSummaries)
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/index.js